import React from 'react';
import FadeIn from '../common/FadeIn';
import { GoDotFill } from "react-icons/go";

const setupFeatures = [
  {
    title: "Design Customization",
    value: "(Included) : ",
    desc: "Choose a design and i will add your business content."
  },
  {
    title: "Logo & Branding",
    value: "(Included) : ",
    desc: "Add your logo, colors, fonts, and brand details."
  },
  {
    title: "Contact Form",
    value: "(Included) : ",
    desc: "A simple form for visitors to send you a message."
  },
  {
    title: "Google Maps",
    value: "(Included) : ",
    desc: "Show your business location so customers can find you."
  },
  {
    title: "WhatsApp Button",
    value: "(Included) : ",
    desc: "Let visitors contact you directly on WhatsApp."
  },
  {
    title: "Domain & HTTPS",
    value: "(Included) : ",
    desc: "Connect your domain and set up a secure website."
  }
];

const hostingFeatures = [
  {
    title: "Web Hosting",
    value: "(Included) : ",
    desc: "Fast and reliable hosting for your website."
  },
  {
    title: "Email Setup",
    value: "(Included) : ",
    desc: "Help make sure website messages reach your inbox."
  },
  {
    title: "Cookie Notice",
    value: "(Included) : ",
    desc: "Add a simple cookie notice for your visitors."
  },
  {
    title: "Image Optimization",
    value: "(Included) : ",
    desc: "Optimize images to help your website load faster."
  },
  {
    title: "Website Backups",
    value: "(Included) : ",
    desc: "Regular backups help keep your website data safe."
  },
  {
    title: "Security & Anti-Spam",
    value: "(Included) : ",
    desc: "Help protect your website from spam and unwanted activity."
  },
  {
    title: "Text & Photo Updates",
    value: "(Included) : ",
    desc: "Send us your updates and i will make the changes for you."
  }
];

const ServicePricingSection = () => {
  return (
    <section className="w-full bg-[#121212] text-white py-12 sm:py-16 md:py-20 px-6 sm:px-10 md:px-16 lg:px-24 border-t border-[#222]">
      <div className="max-w-[1240px] mx-auto">

        <div className="text-center max-w-[800px] mx-auto mb-0 sm:mb-20">
          <FadeIn>
            <h6 className="font-interDisplayMedium leading-[1.8] w-fit mx-auto tracking-[0.2em] font-medium text-[15px] text-[#ce884d] border-b border-[#ce884d] mb-4">
              PRICING
            </h6>
          </FadeIn>

          <FadeIn>
            <h2 className="font-saolDisplayItalic text-[27px] md:text-[36px] leading-[1.7] font-bold mb-2 md:mb-3">
              SIMPLE PRICING.
            </h2>
          </FadeIn>

          <FadeIn>
            <p className="font-interDisplayMedium text-[13px] sm:text-[14.5px] font-light text-white leading-[1.75] max-w-[660px] mx-auto">
              Simple pricing with no hidden charges. You will know what you are paying for and what is included.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-0 items-start divide-y lg:divide-y-0 lg:divide-x divide-white">

          <div className="w-full pt-8 lg:pt-0 lg:pr-12">
            <FadeIn>
              <h3 className="font-saolDisplayItalic text-[27px] md:text-[36px] leading-[1.7] font-bold mb-0 md:mb-3">
                Website Setup & Launch
              </h3>
            </FadeIn>

            <FadeIn>
              <div className="font-interDisplayMedium text-[31px] leading-[1.7] font-normal mb-0 md:mb-8">
                $299 One-Time setup
              </div>
            </FadeIn>

            <FadeIn>
              <h4 className="font-interDisplayMedium text-[20px] font-medium text-white mb-[12px] md:mb-5">
                What we do for you:
              </h4>
            </FadeIn>

            <ul className="space-y-4 text-[13px] sm:text-[14px] font-interDisplayMedium font-light leading-[1.7] text-[#D1D1D1]">
              {setupFeatures.map((item, idx) => (
                <FadeIn key={idx}>
                  <li className="flex items-start gap-2 text-white">
                    <span className="text-[#C6A888] mt-1.5 text-[8px]"><GoDotFill className="text-[#ce884d] text-md" /></span>
                    <div>
                      <strong className="font-interDisplayMedium text-[14px] tracking-[0.03em] leading-[26px] font-semibold">{item.title}</strong>{' '}
                      {item.value && <span>{item.value}</span>}
                      {item.desc}
                    </div>
                  </li>
                </FadeIn>
              ))}
            </ul>
          </div>

          <div className="w-full pt-10 lg:pt-0 lg:pl-12">
            <FadeIn>
              <h3 className="font-saolDisplayItalic text-[27px] md:text-[36px] leading-[1.7] font-bold mb-0 md:mb-3">
                Yearly Web Hosting & Maintenance
              </h3>
            </FadeIn>

            <FadeIn>
              <div className="font-interDisplayMedium text-[31px] leading-[1.7] font-normal mb-0 md:mb-8">
                $199 / Year
              </div>
            </FadeIn>

            <FadeIn>
              <h4 className="font-interDisplayMedium text-[20px] font-medium text-white mb-[12px] md:mb-5">
                Why do you need this?
              </h4>
            </FadeIn>

            <ul className="space-y-4 text-[13px] sm:text-[14px] font-interDisplayMedium font-light leading-[1.7] text-[#D1D1D1]">
              {hostingFeatures.map((item, idx) => (
                <FadeIn key={idx}>
                  <li className="flex items-start gap-2 text-white">
                    <span className="text-[#C6A888] mt-1.5 text-[8px]"><GoDotFill className="text-[#ce884d] text-md" /></span>
                    <div>
                      <strong className="font-medium leading-[26px] tracking-[0.03em] text-[14px]">{item.title}</strong>{' '}
                      {item.value && <span>{item.value}</span>}
                      {item.desc}
                    </div>
                  </li>
                </FadeIn>
              ))}
            </ul>
          </div>

        </div>

      </div>
    </section>
  );
};

export default ServicePricingSection;
